import * as React from 'react';
import Ellipsis from 'ant-design-pro/lib/Ellipsis';
import { nullSafeGet, nullSafeGetOrElse } from '../../utils/DataAccessUtils';
import PartOrEquipmentAvatar from '../common/PartOrEquipmentAvatar';
import GreyStatusTag from '../equipment_per_stock_location_row_display/GreyStatusTag';
import { Tag } from 'antd';
import PartsLabelDisplay from '../LabelDisplay/PartsLabelDisplay';
import { LabelEntityType, PartsAddLabelButton } from '../LabelSystem';
import AccessPermissionChecker from '../common/AccessPermissionChecker';
import { PERMISSION_NAMES } from '../../utils/AuthUtils';

require('./PartPerStockLocationRowDisplay.less');

export const PartPerStockLocationRowDisplay: React.FC<any> = ({
	partPerStockLocation,
	hideImage,
	refreshTable,
	...props
}) => {
	const partId = nullSafeGet('part.id', partPerStockLocation);
	// Prefer hydrated partLabels; fall back to bare { id } objects from labelIds so the
	// Add Label modal seeds the already-associated ids into its selection. Without this,
	// a row that only has labelIds (not hydrated partLabels) opens the modal with an empty
	// selection, and saving would send only the newly picked ids — dropping existing labels.
	const partLabels = nullSafeGetOrElse('part.partLabels', partPerStockLocation, []);
	const existingLabels = partLabels.length
		? partLabels
		: nullSafeGetOrElse('part.labelIds', partPerStockLocation, []).map((id) => ({ id }));
	return (
		<div
			className="partPerStockLocationRowDisplay group"
			style={{ justifyContent: 'space-between' }}
			{...props}
		>
			<div className="partPerStockLocationRowDisplay">
				{!hideImage && (
					<div style={{ marginRight: 24 }}>
						<PartOrEquipmentAvatar item={partPerStockLocation.part || {}} />
					</div>
				)}
				<div>
					<div className="partPerStockLocationRowDisplay__rowTitle flex min-h-[32px] items-center">
						<Ellipsis tooltip={true} length={56} className={'pb-0.5'}>
							{nullSafeGet('part.name', partPerStockLocation)}
						</Ellipsis>
						{partId ? (
							<AccessPermissionChecker name={PERMISSION_NAMES.MODIFY_PARTS_AND_EQUIPMENTS}>
								<div className="ml-2 hidden shrink-0 group-hover:inline-flex">
									<PartsAddLabelButton
										entityType={LabelEntityType.PART}
										entityId={partId}
										existingLabels={existingLabels}
										refreshTable={refreshTable}
									/>
								</div>
							</AccessPermissionChecker>
						) : null}
					</div>
					<div className="partPerStockLocationRowDisplay__rowSubtitle">
						{nullSafeGet('part.partNumber', partPerStockLocation) ? (
							<div className="partPerStockLocationRowDisplay__rowInlineGroup">
								Part #{nullSafeGet('part.partNumber', partPerStockLocation)}
							</div>
						) : null}
						{nullSafeGet('part.description', partPerStockLocation) && (
							<div
								className="partPerStockLocationRowDisplay__rowInlineGroup"
								style={{ display: 'inline-flex' }}
							>
								<Ellipsis tooltip={true} length={80}>
									{nullSafeGet('part.description', partPerStockLocation)}
								</Ellipsis>
							</div>
						)}
						{nullSafeGet('part.manufacturerName', partPerStockLocation) && (
							<div>Manufacturer: {nullSafeGet('part.manufacturerName', partPerStockLocation)}</div>
						)}
						<PartsLabelDisplay
							className="mb-3 mt-2"
							labels={nullSafeGetOrElse('part.partLabels', partPerStockLocation, [])}
						/>
					</div>
					<div className="partPerStockLocationRowDisplay__rowSubtitle mt-2 flex flex-row items-center">
						<Tag className="flex flex-row whitespace-nowrap">{`Aisle ${nullSafeGetOrElse(
							'aisle',
							partPerStockLocation,
							'--'
						)}`}</Tag>
						<Tag className="ml-2 flex flex-row whitespace-nowrap">{`Bay ${nullSafeGetOrElse(
							'bay',
							partPerStockLocation,
							'--'
						)}`}</Tag>
						<Tag className="ml-2 flex flex-row whitespace-nowrap">{`Level ${nullSafeGetOrElse(
							'level',
							partPerStockLocation,
							'--'
						)}`}</Tag>
						<Tag className="ml-2 flex flex-row whitespace-nowrap">{`Bin ${nullSafeGetOrElse(
							'bin',
							partPerStockLocation,
							'--'
						)}`}</Tag>
					</div>
					{!partPerStockLocation.isStocked && (
						<div className="partPerStockLocationRowDisplay__rowSubtitle mt-2">
							<GreyStatusTag text="Not Stocked" />
						</div>
					)}
				</div>
			</div>
		</div>
	);
};
